/* eslint-disable quotes, quote-props, comma-dangle  */

const translations = {
  "loading-label": [{
    "type": 0,
    "value": "يتم الآن التحميل"
  }]
};
function TranslationProviderComponent({
  children
}) {
  return children(translations);
}
var arAE = Object.assign(TranslationProviderComponent, {
  translations
});

export { arAE as a };
//# sourceMappingURL=ar-AE-HQY8WN1w.js.map
